import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import {
  checkIfUserNameExist,
  mobileVerification,
  registerUser,
  sendOtpToEmail,
  sendOtpToMobile,
  verifyEmailOtp,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { APP_CONST, AFF_KEY_LS } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-input-2";
import { FiEye, FiEyeOff } from "react-icons/fi";
import UseAppendScript from "../../../hooks/useAppendScript";
import useAppendNewScript from "../../../hooks/useAppendNewScript";
import { useTranslation } from "react-i18next";
// import LoginLeftPart from "../../../assets/images/modal.gif";

/**
 *
 * @param {string} mobileNumber
 */
const getParsedMobile = (mobileNumber) => {
  const phoneNumber = parsePhoneNumber("+" + mobileNumber);
  return {
    mobile: phoneNumber?.nationalNumber || "",
    country_code: phoneNumber?.countryCallingCode | "",
  };
};

const RegisterModal = ({
  show,
  handleClose,
  handleModalShow,
  agentCode: agentCodeProp,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPasswordValidtions, setShowPasswordValidations] = useState(false);
  const [validationIndex, setValidationIndex] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const appendScript = UseAppendScript();
  const { appendScript: addScript } = useAppendNewScript({
    scriptId: "complt-register",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [referalCode, setReferalCode] = useState(location?.state?.referalCode);
  const [isReffered, setIsReffered] = useState(false);
  const [cookies, setCookie] = useCookies(["refferal"]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agentCode, setAgentCode] = useState(agentCodeProp);
  const [agentCookies, setAgentCookie] = useCookies(["agentCode"]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtpValue] = useState("");

  const { t } = useTranslation();

  const [userNameConfig, setUserNameConfig] = useState({
    isUserNameExist: false,
    message: t("user_name_is_available"),
  });

  const validationMessages = [
    { text: t("at_least_8_symbols"), key: 1 },
    { text: t("at_least_1_digit"), key: 2 },
    { text: t("at_least_1_lowercase_characters"), key: 3 },
    { text: t("at_least_1_uppercase_characters"), key: 4 },
  ];

  const affId = localStorage.getItem(AFF_KEY_LS);
  const appDetails = useSelector((state) => state.app?.appDetails);
  const [email, setEmail] = useState({ email: "" });

  const [isLoading, setIsLoading] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;

  

  const sendEmailOTPSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!Boolean(email.email) || email.email == "") {
      return;
    }

    const response = await sendOtpToEmail(email);
    if (response) {
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || t("OTP_sent")
      );
    }
    setIsLoading(false);
  };

  // const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState("");

  const verifyEmailOtpSubmit = async (e) => {
    e.preventDefault();
    if (!otp) {
      return;
    }
    setIsVerifying(true);
    const response = await verifyEmailOtp({
      email: email?.email,
      otp: otp,
    });
    if (response) {
      setIsEmailVerified(true);
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        response?.data?.message || t("OTP_verified")
      );
    }
    setIsVerifying(false);
  };
  const checkForPasswordValidations = (e) => {
    const password = e.target.value;
    let fulfilledindex = [];
    if (password.length >= 8) {
      fulfilledindex.push(1);
    }
    if (/\d/.test(password)) {
      fulfilledindex.push(2);
    }
    const smallAlp = new RegExp("(?=.*[a-z])");
    if (smallAlp.test(password)) {
      fulfilledindex.push(3);
    }
    const capAlp = new RegExp("(?=.*[A-Z])");
    if (capAlp.test(password)) {
      fulfilledindex.push(4);
    }
    setValidationIndex(fulfilledindex);
  };

  useEffect(() => {
    if (referalCode) {
      setCookie("code", referalCode);
      setReferalCode(referalCode);
      setIsReffered(true);
    } else if (cookies?.code) {
      setReferalCode(cookies.code);
      setIsReffered(true);
    }
  }, [cookies, referalCode]);

  useEffect(() => {
    if (agentCode) {
      setAgentCookie("agent", agentCode);
    } else if (agentCookies?.agent) {
      setAgentCode(agentCookies?.agent);
    }
  }, [agentCookies, agentCode]);

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { name, username, password, confirmPassword } = dataToValidate;
    const newErrors = {};
    // if (!name || name === "") {
    //   newErrors.name = "Name cannot be empty";
    // }
    if (!username || username === "") {
      newErrors.userName = t("user_name_cannot_be_empty");
    }
    if (username && (username.length < 4 || username.length > 15)) {
      newErrors.userName = t("username_must_be_4_to_15_characters");
    }
    if (!/^[A-Za-z0-9 ]+$/.test(username)) {
      newErrors.userName = t("special_characters_are_not_allowed_in_username");
    }
    if (!password || password === "") {
      newErrors.password = t("password_cannot_be_empty");
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = t("password_must_be_8_to_20_characters");
    }
    // if (!confirmPassword || confirmPassword === "") {
    //   // newErrors.confirmPassword = "Confirm password cannot be empty";
    // } else if (password !== confirmPassword) {
    //   // newErrors.confirmPassword = "Password and Confirm password must be same";
    // }

    setErrors(newErrors);
    return newErrors;
  };

  const scriptLoad = () => {
    appendScript(`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '570847040189148');
fbq('init', '1579555345780712');
fbq('init', '1265942443607417');
fbq('init', '1439285079537929');
fbq('trackCustom', 'Goa777CompleteRegistration');`);

    addScript(`
    !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '716009664397945');
fbq('track', 'CompleteRegistration');
    `);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorsData = validateData();

    if (Object.keys(errorsData).length > 0) {
      return;
    }

    let dataToSend = { ...formData };
    if (isEmailOtpRequired) {
      if (!Boolean(mobileNumber)) {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, t("mobile_is_required"));
      }
      dataToSend = {
        ...dataToSend,
        ...getParsedMobile(mobileNumber),
        email: email?.email,
      };
    } else {
      dataToSend.mobile = registerConfig?.mobileDetails?.mobile;
      dataToSend.country_code = registerConfig?.mobileDetails?.country_code;
    }

    dataToSend.name = formData?.username;

    delete dataToSend.confirmPassword;
    if (agentCode) {
      dataToSend.agent_code = agentCode;
    }

    // Send tracking id , if exist
    if (affId) {
      dataToSend.affId = affId;
    }

    dispatch(
      registerUser(
        {
          ...dataToSend,
          typeId: 3,
          parentId: 81026,
          // mobile: registerConfig.mobileDetails?.mobile,
          // country_code: registerConfig.mobileDetails.country_code,
        },
        () => scriptLoad()
      )
    );
    // checkIfExistingUserDetails(formData);
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  const [registerConfig, setRegisterConfig] = useState({
    isOtpEnabled: useSelector((state) => state?.app?.appDetails?.OTP) === 0,
    mobileDetails: {},
    isSendingOtp: false,
    isVerifyingOtp: false,
    isOtpSent: false,
    isOtpVerified: false,
    showPassword: false,
    showConfirmPassword: false,
  });

  const handleRegisterConfigChange = (config) => {
    setRegisterConfig((p) => ({ ...p, ...config }));
  };

  const sendOtp = () => {
    handleRegisterConfigChange({
      isSendingOtp: true,
    });
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    payload.mobile = phoneNumber.nationalNumber;
    payload.country_code = phoneNumber.countryCallingCode;

    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        handleRegisterConfigChange({
          mobileDetails: payload,
          isOtpSent: true,
          isSendingOtp: false,
        });
        if (res?.data?.error === false) {
          Toaster(
            APP_CONST.TOAST_TYPE.SUCCESS,
            res?.data?.message || "OTP sent"
          );
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        handleRegisterConfigChange({
          isSendingOtp: false,
        });
      });
  };

  const verifyOtp = () => {
    handleRegisterConfigChange({
      isVerifying: true,
    });
    dispatch(mobileVerification({ ...registerConfig.mobileDetails, otp }))
      .then((res) => {
        handleRegisterConfigChange({
          isVerifying: false,
          isOtpVerified: true,
        });
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, t("OTP_verified"));
      })
      .catch((err) => {
        handleRegisterConfigChange({
          isVerifying: false,
        });
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  };

  const checkUserName = async () => {
    if (formData?.username) {
      const response = await checkIfUserNameExist({
        username: formData?.username,
      });
      if (response && response?.data?.error === false) {
        setUserNameConfig({
          userNameExist: false,
          message: t("username_is_available"),
        });
      } else {
        setUserNameConfig({
          isUserNameExist: true,
          message: t("username_is_already_taken"),
        });
      }
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal register"}
      onHide={() => {
        console.log("working");
      }}
      centered
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      ></Modal.Header>

      <Modal.Body>
        <Modal.Title className="mb-4">{t("registration")}</Modal.Title>
        <div className="form-steps">
          <Form>
            {/* <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={"text"}
                name="name"
                placeholder="Name*"
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.name}
              </Form.Control.Feedback>
            </Form.Group> */}
            <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type="text"
                name="username"
                placeholder={t("username_reg")}
                onChange={handleChange}
                isInvalid={!!errors.userName}
                // onBlur={checkUserName}
              />

              <Form.Control.Feedback type="invalid">
                {errors?.userName}
              </Form.Control.Feedback>
            </Form.Group>
            {/* <div
              className="user_avail"
              style={
                userNameConfig.isUserNameExist
                  ? { color: "#bc2f3e", fontSize: "12px" }
                  : { color: "#198754", fontSize: "12px" }
              }
            >
              {formData?.username && userNameConfig.message}
            </div> */}
            <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder={t("password_reg")}
                autoComplete="new-password"
                onChange={(e) => {
                  handleChange(e);
                  checkForPasswordValidations(e);
                }}
                isInvalid={!!errors.password}
                onFocus={() => {
                  setShowPasswordValidations(true);
                }}
              />
              <span className="icon" onClick={() => setShowPassword((p) => !p)}>
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.password}
              </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password*"
                onChange={handleChange}
                isInvalid={!!errors.confirmPassword}
                onFocus={() => {
                  setShowPasswordValidations(true);
                }}
              />
              <span
                className="icon"
                onClick={() => setShowConfirmPassword((p) => !p)}
              >
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.confirmPassword}
              </Form.Control.Feedback>
            </Form.Group> */}
            {showPasswordValidtions && (
              <div className="password-note">
                <ul>
                  {validationMessages.map((item, index) => {
                    const result = validationIndex.find((i) => i === item.key);
                    return (
                      <li className={result ? "pwd-validation-message" : ""}>
                        {item?.text}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            <Form.Group
              className="position-relative"
              controlId="formBasicPassword"
            >
              <Form.Control
                type={"text"}
                name="agent_code"
                placeholder={t("please_enter_referral_code")}
                value={agentCode}
                onChange={(e) => setAgentCode(e.target.value)}
              />
            </Form.Group>

            {!isEmailOtpRequired && (
              <>
                {" "}
                <div className="get-otp mb-2">
                  <Form.Group
                    className="position-relative"
                    controlId="formBasicPassword"
                  >
                    <PhoneInput
                      country={"in"}
                      countryCodeEditable={false}
                      inputProps={{
                        name: "phone",
                        required: true,
                      }}
                      inputStyle={{ width: "100%" }}
                      onChange={(phone) => {
                        setMobileNumber(phone);
                      }}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    onClick={sendOtp}
                    disabled={
                      registerConfig.isSendingOtp ||
                      userNameConfig.isUserNameExist === true
                    }
                  >
                    {registerConfig.isSendingOtp ? t("loading_reg") : t("submit_reg")}
                  </Button>
                  {registerConfig?.isOtpEnabled && (
                    <p className="otpnote">
                      <span>{t("note")}</span>{t("user_can_request_a_new_otp_after_every_five_minutes")}
                    </p>
                  )}
                </div>
                {registerConfig?.isOtpEnabled && (
                  <div className="verify-otp">
                    <Form.Group
                      className="mb-4 position-relative"
                      controlId="formBasicPassword"
                    >
                      <Form.Control
                        type="text"
                        placeholder={t("enter_OTP")}
                        onChange={(e) => setOtpValue(e.target.value)}
                      />
                    </Form.Group>

                    <Button
                      variant="primary"
                      onClick={verifyOtp}
                      disabled={
                        registerConfig.isVerifyingOtp ||
                        !registerConfig.isOtpSent ||
                        !otp
                      }
                    >
                      {!registerConfig.isOtpVerified
                        ? !registerConfig.isVerifyingOtp
                          ? t("VERIFY_OTP")
                          : t("SUBMITTING")
                        : t("VERIFIED")}
                    </Button>
                  </div>
                )}
              </>
            )}

            {isEmailOtpRequired && (
              <>
                <div className="get-otp mb-2">
                  <Form.Group
                    className="position-relative"
                    controlId="formBasicPassword"
                  >
                    <PhoneInput
                      country={"mx"}
                      countryCodeEditable={false}
                      inputProps={{
                        name: "phone",
                        required: true,
                      }}
                      inputStyle={{ width: "100%" }}
                      onChange={(phone) => {
                        setMobileNumber(phone);
                      }}
                    />
                  </Form.Group>
                </div>
                <Form>
                  <Form.Group
                    className="mb-3 position-relative"
                    controlId="formBasicPassword"
                  >
                    <Form.Control
                      type="email"
                      placeholder={t("Enter_email")}
                      value={email.email}
                      onChange={(e) => setEmail({ email: e.target.value })}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    // type="submit"
                    onClick={sendEmailOTPSubmit}
                    className="loginbtn"
                    disabled={isLoading || !Boolean(email.email)}
                  >
                    {isLoading ? t("loading_reg") : t("Send_OTP_to_email")}
                  </Button>
                </Form>
                <Form>
                  <Form.Group
                    className="mb-3 position-relative"
                    controlId="formBasicPassword"
                  >
                    <Form.Control
                      type="text"
                      value={otp}
                      placeholder={t("enter_OTP")}
                      onChange={(e) => setOtpValue(e.target.value)}
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    disabled={isVerifying}
                    onClick={verifyEmailOtpSubmit}
                  >
                    {!isVerifying ? t("VERIFY") : t("SUBMITTING")}
                  </Button>
                </Form>
              </>
            )}
            <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "end",
                  gap: "8px",
                }}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  style={{ marginTop: "4px" }}
                />
                <span style={{ fontSize: "10px", color: "#000" }}>
                 {t("By_clicking_register_you_agree_to_our")}
                  <a href="/termss" target="_blank" rel="noopener noreferrer">
                    {t("Terms_of_Service")}
                  </a>{" "}
                  {t("reg_check_box_note")}
                </span>
              </label>
            </div>
            <Button
              variant="primary"
              type="submit"
              className="register mb-0"
              onClick={handleSubmit}
              disabled={
                !isChecked ||
                (isEmailOtpRequired && !isEmailVerified) ||
                registerConfig?.isOtpEnabled
                  ? !registerConfig?.isOtpVerified
                  : !registerConfig?.isOtpSent
              }
            >
              {t("Register")}
            </Button>
          </Form>

          <div className="register-back">
            <span>{t("Already_have_an_account")}</span>
            <a
              href="#"
              onClick={() => {
                handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                handleClose(APP_CONST.AUTH_MODAL.REGISTER);
              }}
            >
             {t("Login")}
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
